export default __webpack_public_path__ + "static/media/sch_info_icon_gray.aa57d009.svg";